import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/clinic-lab/Dashboard/Index.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import CompanyConfig from "../views/clinic-lab/Config/Company/Company.vue";
import TestConfig from "../views/clinic-lab/Config/Tests/Index.vue";
import TestCreate from "../views/clinic-lab/Config/Tests/Create.vue";
import PricesConfig from "../views/clinic-lab/Config/Prices/Index.vue";
import PriceEdit from "../views/clinic-lab/Config/Prices/Edit.vue";
import PriceCreate from "../views/clinic-lab/Config/Prices/Create.vue";
import Clients from "../views/pago-app/Clients/Index.vue";
import ClientCreate from "../views/pago-app/Clients/Create.vue";
import ClientEdit from "../views/pago-app/Clients/Edit.vue";
import Loans from "../views/pago-app/Loans/Index.vue";
import LoanCreate from "../views/pago-app/Loans/Create.vue";
import LoanEdit from "../views/clinic-lab/Results/Edit.vue";
import LoanView from "../views/pago-app/Loans/View.vue";
import Products from "../views/pago-app/Products/Index.vue"
import ProductView from "../views/pago-app/Products/View.vue"
import ProductCreate from "../views/pago-app/Products/Create.vue";
import PaymentCreate from "../views/pago-app/Payments/Create.vue";
import Invoices from "../views/pago-app/Invoices/Index.vue";
import InvoiceView from "../views/pago-app/Invoices/View.vue";
import InvoiceCreate from "../views/pago-app/Invoices/Create.vue";
const routes = [
  {
    path: "/",
    name: "/",
    component: Dashboard,
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
  },
  //Settings
  {
    path: "/company-settings",
    name: "Compañia",
    component: CompanyConfig,
  },
  //Test Settings
  {
    path: "/test-settings",
    name: "Exámenes",
    component: TestConfig,
  },
  {
    path: "/create-test",
    name: "Crear Examen",
    component: TestCreate,
  },
  //Prices settings
  {
    path: "/prices-settings",
    name: "Precios",
    component: PricesConfig,
  },
  {
    path: "/create-price",
    name: "Crear Precio",
    component: PriceCreate,
  },
  {
    path: "/edit-price",
    name: "Editar Precio",
    component: PriceEdit,
  },
  //Clients
  {
    path: "/clients",
    name: "Clientes",
    component: Clients,
  },
  {
    path: "/create-client",
    name: "Crear Cliente",
    component: ClientCreate,
  },
  {
    path: "/edit-client/:id",
    name: "Editar Cliente",
    component: ClientEdit,
  },
  //Loans
  {
    path: "/loans",
    name: "Créditos",
    component: Loans,
  },
  {
    path: "/create-loan/:id",
    name: "Crear Crédito",
    component: LoanCreate,
  },
  {
    path: "/edit-loan/:id",
    name: "Editar Crédito",
    component: LoanEdit,
  },
  {
    path: "/view-loan/:id",
    name: "Ver Crédito",
    component: LoanView,
  },
  //Products
  {
    path:"/products",
    name: "Productos",
    component:Products
  },
  {
    path:"/create-product",
    name: "Crear producto",
    component:ProductCreate
  },
  {
    path: "/view-product/:id",
    name: "Ver Producto",
    component: ProductView,
  },
  //Invoices
  {
    path:"/invoices",
    name:"Facturas",
    component: Invoices
  },
  {
    path:"/view-invoice/:id",
    name:"Detalle de Factura",
    component: InvoiceView
  },
  {
    path:"/create-invoice",
    name:"Crear Factura",
    component: InvoiceCreate
  },
  //Payments
  {
    path:"/create-payment/:id",
    name: "Crear pago",
    component:PaymentCreate
  },
  //
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
